import { ProductGroup } from '@app/core/models/client';
import {
  Header,
  StyleProvider,
  defaultBrandingData,
} from '@relaynetwork/design-system';
import React, { useMemo } from 'react';

type ProductGroupPreviewProps = {
  showProductGroup: boolean;
  productGroupName: string;
  productGroupDescription?: string;
  bannerUrl?: string;
  logoUrl: string;
  color: string;
  isPreview?: boolean;
  showFDIC?: boolean;
  fdic?: ProductGroup['fdic'];
  showBanner?: boolean;
  showLogo?: boolean;
  showTitleBar?: boolean;
  showMenu?: boolean;
};
export const FeedHeader = ({
  productGroupDescription = '',
  showProductGroup,
  productGroupName,
  bannerUrl = '',
  logoUrl,
  color,
  isPreview,
  showFDIC = false,
  fdic = {
    non_deposit_language: '',
    show_signage_on_authentication: false,
    type: null,
  },
  showBanner = true,
  showLogo = true,
  showTitleBar = true,
  showMenu = true,
}: ProductGroupPreviewProps) => {
  const brandingData = useMemo(
    () => ({
      ...defaultBrandingData,
      color: color,
    }),
    [color],
  );

  return (
    <StyleProvider brandingData={brandingData}>
      <Header
        productGroupName={showProductGroup ? productGroupName : ' '} // passing an empty space, will be updated in the future with a design-system change.
        productGroupDescription={productGroupDescription}
        bannerUrl={bannerUrl}
        logoUrl={logoUrl}
        showBanner={showBanner}
        showLogo={showLogo}
        showTitleNavBar={showTitleBar}
        showRegularNavBar
        isPreview={isPreview}
        isMobile
        isPortrait={true}
        fdic={fdic}
        showMenu={showMenu}
        showFDICSignageOnFeed={showFDIC}
      />
    </StyleProvider>
  );
};
